import {MoleculeEvent} from "./MoleculeEvent.js";

export class EventRepository {
    /** @type {HttpClient} */
    #httpClient;

    /** @param {HttpClient} httpClient */
    constructor(httpClient) {
        this.#httpClient = httpClient;
    }

    /**
     * @param {string[]} structureIds
     * @param {string[]} eventNames
     * @param {string[]} context
     * @param {string} lastId
     * @returns {Promise<MoleculeEvent[]>}
     */
    async loadEvents(structureIds, eventNames, context, lastId) {
        const structureIdParams = structureIds.length > 0 ? 'structureId=' + structureIds.join(',') : '';
        const lastIdParam = lastId ? '&after=' + lastId : '';
        const eventParams = eventNames.length > 0 ? '&eventNames=' + eventNames.join(',') : '';
        const contextParams = context.length > 0 ? '&context=' + context.join(',') : '';
        let params = '';
        if(structureIdParams || eventParams || lastIdParam || contextParams)
            params = "?" + structureIdParams + lastIdParam + eventParams + contextParams;

        const response = await this.#httpClient.fetch('/api/event' + params);
        return Promise.resolve(MoleculeEvent.parseServerJsonList(await response.json()));
    }

    async createEvents(events) { // for tests only
        return (await this.#httpClient.fetch('/api/event', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        })).json();
    }
}